import { List } from '@mui/material';
import { ListChild } from './list-child';

export const ListChildren = ({ userChildren, getUserChildren }) => {
    return (
        <>
            {(!userChildren.length) ?
                <p>Поки що дітей не додано</p> :
                <List sx={{
                    width: '100%',
                    maxWidth: 700,
                    margin: '0 auto',
                    backgroundColor: 'white',
                    borderRadius: '4px'
                }}>
                    {userChildren.map(child => (
                        <ListChild key={child.id}
                            child={child}
                            getUserChildren={getUserChildren} />
                    ))}
                </List>
            }
        </>
    )
}